<template>
  <section class="maintenance-page">
    <VoodooTuneLogo class="voodootune-logo" />
    <section class="centered-wrapper">
      <div class="robots"></div>
      <img :src="illustration" alt="maintenance robots" class="illustration" />
      <h1>We are under maintenance</h1>
      <p class="maintenance-message">
        <span>Sorry, we are currently improving our website.</span>
        <span>We will be back soon... we promise you!</span>
      </p>
      <vd-button type="primary" @click="reload">Refresh</vd-button>
    </section>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import VoodooTuneLogo from "@/assets/VoodooTuneLogo.vue";

import illustration from "./assets/illustration-maintenance.svg";

export default defineComponent({
  name: "MaintenancePage",
  components: {
    VoodooTuneLogo,
  },
  props: {},
  setup() {
    const reload = () => {
      window.location.replace("/");
    };

    return {
      reload,
      illustration,
    };
  },
});
</script>

<style lang="scss" scoped>
.maintenance-page {
  display: grid;
  justify-items: center;
  position: absolute;
  width: 50%;
  left: 50%;
  top: 20px;
  height: 100%;
  transform: translateX(-50%);
  text-align: center;

  .voodootune-logo {
    display: inline-block;
    margin-bottom: 100px;
  }

  .centered-wrapper {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .illustration {
    width: 350px;
    margin-bottom: 30px;
  }

  h1 {
    width: 279px;
    height: 90px;
    font-size: 40px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.13;
    letter-spacing: normal;
    text-align: center;
    background-color: #d3ebfc;
    color: #d3ebfc;
    text-shadow: 0px 1px 3px rgb(255, 255, 255);
    -webkit-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;

    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }

  .maintenance-message {
    margin-bottom: 30px;

    span {
      display: block;
    }
  }
}
</style>
